import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { hasFeature } from 'client/modules/Auth/AuthReducer';
import UpgradeCTA from './UpgradeCTA';

function RequireFeature({ feature, children }) {
  const allowed = useSelector(state => hasFeature(state, feature));

  if (!allowed) {
    return <UpgradeCTA feature={feature} fullPage />;
  }

  return children;
}

RequireFeature.propTypes = {
  feature: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default RequireFeature;
